// Resume section content.
// Same link-placeholder pattern as services.js for entries that need an
// inline link (e.g. the AP+ podcast entry).
module.exports = {
  experience: [
    {
      yearRange: "2020 to Present",
      title: "Senior Solutions Architect",
      place: "Amazon Web Services (AWS)",
      desc:
        "Lead strategic technology advisory and C-suite partnerships across Australia's largest financial services organisations and high-growth digital native companies. Trusted technology partner to executive leadership teams architecting national-scale platforms, driving enterprise transformation, and positioning technology as competitive advantage.",
      highlights: [
        "Architected cloud foundation for national-scale payment infrastructure processing 1.8B annual transactions with 99.995% availability",
        "Transformed major competitive threat from a leading cloud provider into a multi-year strategic partnership through superior technical leadership",
        "Delivered millions in operational savings through AI/ML implementations, reducing critical process times from days to minutes",
        "Led security strategy for major fintech blocking 20M+ threats daily with complete automated remediation",
        "Influenced AWS product roadmaps through strategic customer advocacy, creating new service features benefiting entire ecosystems",
        "Generated multi-million dollar pipeline through industry thought leadership, executive roundtables, and strategic payments workshops",
      ],
    },
    {
      yearRange: "2018 to 2020",
      title: "Co-Founder",
      place: "Rovercode",
      desc:
        "Co-founded EdTech platform democratising coding education through accessible robotics and cloud-native architecture. Led technical strategy, architecture, and implementation. Successfully sold the business.",
      highlights: [
        "Architected cloud-native infrastructure supporting real-time robotics control with 99.9% platform availability",
        "Led hardware/software integration combining 3D printing, CAD, and cloud services into a unified learning experience",
      ],
    },
    {
      yearRange: "2017 to 2020",
      title: "Head of Architecture / DevOps",
      place: "SmartFile (Veristack/Lumanox)",
      desc:
        "Led dual strategic initiatives: architecting Veristack data governance platform from concept through customer validation, and directing comprehensive modernisation of SmartFile's 9-year legacy platform for acquisition readiness. Managed $1.2M technology budget.",
      highlights: [
        "Architected patented data governance platform with advanced file fingerprinting and unified security event management",
        "Transformed legacy platform from <95% to >99.9% availability with modern CI/CD, positioning for successful acquisition",
        "Led complete infrastructure overhaul supporting 2.5PB of customer data with 600% compute capacity increase",
      ],
    },
    {
      yearRange: "2013 to 2017",
      title: "Systems Engineer / Architect",
      place: "Indiana University, GlobalNOC",
      desc:
        "Strategic technical leadership for global research network infrastructure serving university and government clients. Architected enterprise authentication and security infrastructure supporting PCI-DSS compliance.",
      highlights: [],
    },
  ],

  experienceFootnote: "Previously in systems engineering and infrastructure roles since 2009.",

  speaking: [
    {
      yearRange: "2023 to 2025",
      title: "AWS re:Invent, Chalk Talk Speaker",
      place: "Las Vegas, NV",
      desc:
        '"Operational Excellence: Best Practices for Resilient Systems" for 3 consecutive years, with consistently high satisfaction scores and strong attendance from enterprise architects worldwide.',
    },
    {
      yearRange: "2022 to 2025",
      title: "AWS Summit Sydney, Speaker",
      place: "Sydney, Australia",
      desc:
        "Presented on database availability, resiliency patterns, and Generative AI across multiple years. Sessions regularly at or above room capacity.",
    },
    {
      yearRange: "2026",
      title: "Australian Payments Plus POV Podcast",
      place: "Sydney, Australia",
      desc:
        "Guest on the AP+ POV podcast discussing payments technology and cloud transformation. {listen}.",
      link: {
        placeholder: "{listen}",
        text: "Listen here",
        url: "https://www.auspayplus.com.au/podcast",
        analyticsEvent: "AP+ Podcast Click",
      },
    },
    {
      yearRange: "Ongoing",
      title: "Industry & Community Leadership",
      place: "Sydney, Australia",
      desc:
        "Keynote speaker at major financial services customer forums. Co-founded Sydney MacAdmins User Group. Facilitate AWS Sydney User Group. Built internal technical community with 200+ members across 50+ departments.",
    },
  ],

  certifications: [
    {
      yearRange: "2025",
      title: "All 12 AWS Certifications",
      place: "Completed in 12 weeks",
      desc:
        "Full portfolio from Cloud Practitioner through Professional and Specialty certifications including Security, Advanced Networking, Machine Learning, and Data Engineering. {verify}.",
      link: {
        placeholder: "{verify}",
        text: "Verify on Credly",
        url: "https://www.credly.com/users/william-laws.3bfa4da4/badges",
        analyticsEvent: "Credly Click Resume",
      },
    },
  ],
};
